import { Dispatch, FC, SetStateAction } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DefaultLoader } from '../../../../../../components/Loaders'
import { PrivateFoundationDetail } from '../../../../../../components/PrivateFoundationDetail'
import { RightSlider } from '../../../../../../components/sliders'
import { MatchedPFSelector } from '../../../../../../store/matchedPF'
import { PrivateFoundationActions } from '../../../../../../store/privateFoundation'
import { AppDispatch } from '../../../../../../store'

interface PFSlideOutProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

export const PFSlideOut: FC<PFSlideOutProps> = ({ open, setOpen }) => {
  const dispatch = useDispatch<AppDispatch>()

  const loading = useSelector(MatchedPFSelector.getLoading)
  const pf = useSelector(MatchedPFSelector.makeMatchedPF)

  const onSliderClose = () => {
    setOpen(false)
    dispatch(PrivateFoundationActions.resetFoundation())
  }

  return (
    <RightSlider
      open={open}
      setOpen={setOpen}
      outerBoxSx={{ width: {xs: '100vw' , sm:'600px'} }}
      closeButtonAction={onSliderClose}
    >
      {loading && <DefaultLoader />}
      {!loading && <PrivateFoundationDetail privateFoundation={pf} />}
    </RightSlider>
  )
}
